import { render, staticRenderFns } from "./RealisationSidebarMainTab.vue?vue&type=template&id=1f55c60c"
import script from "./RealisationSidebarMainTab.vue?vue&type=script&lang=js"
export * from "./RealisationSidebarMainTab.vue?vue&type=script&lang=js"
import style0 from "./RealisationSidebarMainTab.vue?vue&type=style&index=0&id=1f55c60c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports